const maskCpf = (cpf, hiddenDigits = 8) => {
  if (typeof cpf !== 'string') return cpf;
  if (!cpf) return '';

  const digits = cpf.replace(/\D/g, '');

  if (digits.length !== 11) return cpf;

  const visible = digits.slice(0, 11 - hiddenDigits);
  const hidden = 'X'.repeat(hiddenDigits);
  const masked = visible + hidden;

  return `${masked.slice(0, 3)}.${masked.slice(3, 6)}.${masked.slice(
    6,
    9,
  )}-${masked.slice(9)}`;
};

export default maskCpf;
